<template>
	<div class="mtipocargaFormHeader puiformheader">
		<v-row>
			<v-col cols="12">
				<pui-field :label="$t('header.mtipocarga.idtipocarga')" :value="getIdtipocargaValue"></pui-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12">
				<pui-field :label="$t('header.mtipocarga.codtipocargaedi')" :value="getCodtipocargaediValue"></pui-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12">
				<pui-field :label="$t('header.mtipocarga.name')" :value="getNameValue"></pui-field>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { PuiFormHeaderMixin } from '@Pui9Components';

export default {
	name: 'mtipocarga-form-header',
	mixins: [PuiFormHeaderMixin],
	data() {
		return {
			modelName: 'mtipocarga'
		};
	},
	computed: {
		getIdtipocargaValue() {
			return this.model && this.model.idtipocarga ? this.model.idtipocarga : '-';
		},
		getCodtipocargaediValue() {
			return this.model && this.model.codtipocargaedi ? this.model.codtipocargaedi : '-';
		},
		getNameValue() {
			return this.model && this.model.name ? this.model.name : '-';
		},
	}
}
</script>
